(function () {
    'use strict';

    var vacancyHighlightBlocks = document.querySelectorAll(
        '.mol-section-slider'
    );

    for (var i = 0; i < vacancyHighlightBlocks.length; i++) {
        const vacancyGrid =
            vacancyHighlightBlocks[i].querySelector('.cards-grid');

        if (!vacancyGrid) continue;

        const paginationEl =
            vacancyHighlightBlocks[i].querySelector('.pagination');

        new Swiper(vacancyGrid, {
            slidesPerView: 1.2,
            spaceBetween: 16,
            watchOverflow: true,
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.1,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    enabled: false,
                },
            },
        });
    }
})();
